import { User } from './user';
import { WorkflowTemplate } from './workflow-template';
import { Scope } from './scope';
import { WorkflowStep } from './workflow-step';
import { WorkflowExecFile } from './workflow-exec-file';
import { FormSubmission } from './form-submission';
import { WorkflowExecDecision } from './workflow-exec-decision';
import { Contact } from './contact';

export interface WorkflowExec {
    id?: number;

    name: string;

    initiator_user_id?: number;
    initiator_user?: User;

    current_step_id?: number;
    current_step?: WorkflowStep;

    workflow_template_id: number;
    workflow_template: WorkflowTemplate;

    variable_observers_scope_id?: number;
    variable_observers_scope?: Scope;

    files?: WorkflowExecFile[];
    form_submissions?: FormSubmission[];

    taken_decisions?: WorkflowExecDecision[];

    current_target_users?: User[];
    current_target_contacts?: Contact[];

    reserved_by_user_id?: number;
    reserved_by_user?: User;
    
    due_on?: Date;
    assigned_on?: Date;

    status: WorkflowStatus;

    created_at?: Date;
    updated_at?: Date;
}

export enum WorkflowStatus {
    WORKFLOW_STATUS_IN_PROGRESS = 1,
    WORKFLOW_STATUS_PROCESSING = 2,
    WORKFLOW_STATUS_COMPLETED = 3,
    WORKFLOW_STATUS_TIMED_OUT = 4
}